<template>
  <section>
    <el-dialog
      title="修改物料"
      :visible.sync="visible"
      width="800px"
      @close="onClose"
    >
      <el-form ref="form" label-width="140px" :model="form" :rules="rules">
        <el-form-item label="磅单号">
          {{ form.pound_code }}
        </el-form-item>
        <el-form-item label="新订单号" prop="order_code">
          <el-input
            clearable
            v-model="form.order_code"
            placeholder="请输入新订单号"
            class="w-96"
          ></el-input>
        </el-form-item>
        <el-form-item label="新的车辆业务类型" prop="car_business_id">
          <tableSelector
            :multiple="false"
            title="选择车辆业务类型"
            v-model="form.car_business_id"
            :rows.sync="form.car_business"
            url="/api/queue/admin/query_business"
            :params="{
              is_parent: 1,
              state: 1,
              keyword: businessKeyword
            }"
            :columns="carBusinessColumns"
          >
            <div class="mb-4" slot="search">
              <span>关键字：</span
              ><el-input
                class="w-60"
                v-model="businessKeyword"
                placeholder="输入关键字搜索"
              ></el-input>
            </div>
            <template slot="content">
              <div>
                <div v-for="item in form.car_business" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" :underline="false">选择业务类型</el-link>
          </tableSelector>
        </el-form-item>
        <el-form-item label="原因" prop="reason">
          <el-input
            type="textarea"
            class="w-96"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="form.reason"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <template v-if="result">
      <el-dialog :show-close="false" title="修改物料结果" :visible="true" width="800px">
        <el-descriptions :column="1">
          <el-descriptions-item label="结果">修改成功</el-descriptions-item>
          <el-descriptions-item label="修改后数据">
            更改后的订单号：{{ result.order_code }}、物料：{{
              result.chip_type
            }}、车辆业务类型：{{ result.car_business_name }}
          </el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="result = null">关 闭</el-button>
      </span>
      </el-dialog>
    </template>
  </section>
</template>

<script>
import tableSelector from "@/components/tableSelector/index.vue";
export default {
  data() {
    return {
      visible: false,
      businessKeyword: "",
      form: {
        pound_code: "",
        order_code: "",
        car_business_id: [],
        car_business: [],
        reason: ""
      },
      rules: {
        order_code: [
          { required: true, message: "请输入新订单号", trigger: "blur" }
        ],
        car_business_id: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ],
        reason: [{ required: true, message: "请输入原因", trigger: "blur" }]
      },
      carBusinessColumns: [
        { label: "车辆代码", prop: "code" },
        { label: "车辆预约业务类型", prop: "name" }
      ],
      result: null
    };
  },
  components: {
    tableSelector
  },
  computed: {
    hasResult() {
      return !!this.result;
    }
  },
  methods: {
    onOpen(row) {
      this.form.booking_id = row.booking_id;
      this.form.pound_code = row.pound_code;
      this.visible = true;
    },
    onClose() {
      this.form = {
        pound_code: "",
        order_code: "",
        car_business_id: [],
        car_business: [],
        reason: ""
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.onSubmit();
        }
      });
    },
    async onSubmit() {
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/change_order",
          data: {
            booking_id: this.form.booking_id,
            car_business_id: String(this.form.car_business_id),
            reason: this.form.reason,
            order_code: this.form.order_code
          }
        });
        const result = res.data.data;
        this.result = res.data.data;
        this.$emit("ok");
        this.visible = false;
      } catch (error) {}
    }
  }
};
</script>

<style lang="less" scoped></style>
